export const ActiveLiquidityParameters = {
  currentLiquidityParametersId: null,
  isDraft: false
}
